import {MyopElementRef} from "../../common";
import {myopAttributes} from "../../consts";
import {BaseWebComponentMessageHandler} from "./BaseWebComponentMessageHandler";
import {ShadowRootRef} from "../shadowRootRef";
import {DetectedMyopRefsMessage, DetectMyopRefsMessage} from "../../messages";
import {MyopMessages} from "../../common/MyopMessages";

export class DetectMyopRefsMessageHandler extends BaseWebComponentMessageHandler<DetectMyopRefsMessage> {
    innerExecutor = (event: DetectMyopRefsMessage, shadowRootRef: ShadowRootRef) => {

        //debugger;
        const allMyopItems = shadowRootRef.shadowRoot.querySelectorAll(`[${myopAttributes.id}]`);

        let myopRefs: MyopElementRef[] = [];

        allMyopItems.forEach(item => {

            // TODO : take that back to the dashboard?
            //console.log(item, item.getBoundingClientRect());

            const myopId = item.getAttribute(myopAttributes.id);

            if (myopId) {
                //console.log('wc rect',  item.parentElement.getBoundingClientRect(), item.getBoundingClientRect())
                // @ts-ignore
                myopRefs.push(new MyopElementRef(myopId, item.tagName, item.getBoundingClientRect(), item.offsetTop, item.offsetLeft))
            }
        })

        this.messageToHost(new DetectedMyopRefsMessage(event.handlerUniqueId, myopRefs))
    };

    messageType = MyopMessages.DetectMyopRefsMessage;


}
